const LocalExpertiseSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Deep <strong>Local Market Knowledge</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our expertise in the El Paso real estate market is unmatched
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="order-2 md:order-1">
            <img
              src="https://public.readdy.ai/ai/img_res/103a82e2e99b3e2d8b9f9b12f4751f27.jpg"
              alt="El Paso neighborhoods map"
              className="w-full h-full rounded-xl shadow-xl object-cover"
            />
          </div>
          <div className="order-1 md:order-2">
            <h3 className="text-3xl font-bold mb-6 text-gray-900">
              Understanding El Paso's Unique Market
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              El Paso's real estate market is unlike any other in Texas. Situated at the westernmost tip of the state, bordering Mexico and New Mexico, our city presents unique opportunities and challenges for property owners. The <strong>El Paso housing market</strong> is influenced by factors ranging from military presence at Fort Bliss to cross-border commerce and the growing medical and education sectors.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              We've witnessed firsthand how the market has evolved over the past decade and a half. From the housing crisis of 2008 to the recent surge in remote workers relocating to our affordable city, we've navigated every market condition. This experience allows us to provide accurate valuations and fair offers regardless of current market fluctuations.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our team actively monitors neighborhood trends, property values, development projects, and economic indicators specific to El Paso. We know which areas are appreciating, which neighborhoods are seeing revitalization, and how factors like school districts, proximity to Fort Bliss, and access to major highways affect property values.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h3 className="text-3xl font-bold mb-8 text-gray-900 text-center">
            Why Local Expertise Matters
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold mb-3 text-gray-900">Neighborhood Knowledge</h4>
              <p className="text-gray-600">
                We know every El Paso neighborhood intimately, from the historic homes in Sunset Heights to the newer developments in East El Paso.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold mb-3 text-gray-900">Market Trends</h4>
              <p className="text-gray-600">
                Our daily involvement in the local market means we understand current trends and can offer competitive prices.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-community-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold mb-3 text-gray-900">Community Connections</h4>
              <p className="text-gray-600">
                Our relationships with local contractors, title companies, and service providers ensure smooth, efficient transactions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalExpertiseSection;
